import { useEffect, useState } from "react";

const NewsSection = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedNews, setSelectedNews] = useState(null);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const res = await fetch("http://localhost:5000/api/news");
        const data = await res.json();
        if (data.success) {
          setNews(data.data);
        } else {
          setError("Failed to load news");
        }
      } catch (err) {
        setError("Failed to load news");
      } finally {
        setLoading(false);
      }
    };
    fetchNews();
  }, []);

  if (loading) return <div className="py-4 text-center">Loading news...</div>;
  if (error) return <div className="py-4 text-center text-red-500">{error}</div>;
  if (!news.length) return <div className="py-4 text-center text-gray-500">No news available.</div>;

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 h-full flex flex-col">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Latest News</h3>
      <div className="space-y-4 flex-1 overflow-y-auto">
        {news.slice(0, 5).map((article, idx) => (
          <div key={article._id || article.id || (article.title + (article.publishedAt || idx))} className="flex items-center justify-between">
            <button
              className="w-full text-left focus:outline-none hover:bg-gray-50 rounded p-2 transition"
              onClick={() => setSelectedNews(article)}
              tabIndex={0}
              aria-label={`Read full news: ${article.title}`}
            >
              <div className="flex items-center justify-between">
                <h4 className="text-md font-medium text-gray-800 truncate">{article.title}</h4>
                <span className="text-xs text-gray-400 ml-2">{new Date(article.publishedAt).toLocaleDateString()}</span>
              </div>
              <p className="text-xs text-gray-600 mt-1 line-clamp-2">
                {article.content.length > 80 ? article.content.slice(0, 80) + "..." : article.content}
              </p>
            </button>
          </div>
        ))}
      </div>
      {/* Modal for full news */}
      {selectedNews && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <div className="bg-white rounded-lg shadow-lg max-w-lg w-full p-6 relative mx-2">
            <button
              className="absolute top-2 right-2 text-gray-400 hover:text-gray-700 text-2xl font-bold focus:outline-none"
              onClick={() => setSelectedNews(null)}
              aria-label="Close news modal"
            >
              &times;
            </button>
            <h2 className="text-xl font-bold text-gray-900 mb-2">{selectedNews.title}</h2>
            {selectedNews.summary && (
              <p className="text-sm text-gray-500 italic mb-2">{selectedNews.summary}</p>
            )}
            <div className="prose max-w-none text-gray-800 mb-4 whitespace-pre-line">
              {selectedNews.content}
            </div>
            <div className="text-xs text-gray-400 text-right">
              Published: {new Date(selectedNews.publishedAt).toLocaleString()}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NewsSection; 